export enum IpcEvents {
  MENU_CLICK = 'MENU_CLICK', // windows托盘菜单点击，mac顶部菜单点击
  CONTEXT_MENU_CLICK = 'CONTEXT_MENU_CLICK', // 点击右键菜单
  SHOW_CONTEXT_MENU = 'SHOW_CONTEXT_MENU', // 打开右键菜单
  ON_OPERATE_MAIN_LISTENER = 'ON_OPERATE_MAIN_LISTENER', // 主进程监听渲染进程操作，无回调
  INVOKE_OPERATE_MAIN_LISTENER = 'INVOKE_OPERATE_MAIN_LISTENER', // 主进程监听渲染进程操作，有回调
  CLICK_TITLEBAR_MAC = 'CLICK_TITLEBAR_MAC', // Mac 系统上双击头部
  CONSOLE_LOG_MESSAGE = 'CONSOLE_LOG_MESSAGE', // 日志打印
  SIGN_OUT = 'SIGN_OUT', // 退出登录
  WINDOW_MAXIMIZE_MAXIMIZE = 'WINDOW_MAXIMIZE_MAXIMIZE', // 窗口最大化最小化
  FULL_SCREEN = 'FULL_SCREEN', // 全屏
  WINDOW_RESIZE = 'WINDOW_RESIZE', // 窗口尺寸变化
  UPGRADE_DOWNLOAD_PROGRESS = 'UPGRADE_DOWNLOAD_PROGRESS', //  更新下载进度
  CONFIRM_TRANSMISSION_PROGRESS = 'CONFIRM_TRANSMISSION_PROGRESS', // 确认是否存在上传或者下载进程
  CONFIRM_QUIT = 'CONFIRM_QUIT', // 确认退出进程
  WINDOW_SHOW = 'WINDOW_SHOW', // 显示主窗口
  DOWNLOAD_CODE = 'DOWNLOAD_CODE', // Web端拉起客户端批量下载
  NEED_RESTART_SERVER = 'NEED_RESTART_SERVER', // 客户端认为需要重启服务端
  RESTART_SERVER = 'RESTART_SERVER', // 重启服务端
  HANDLE_MEETING_AUTH = 'HANDLE_MEETING_AUTH', // 处理腾讯会议授权后拉起客户端的操作
  COPY_TEXT = 'COPY_TEXT', // 复制文字
  LOGIN_CODE = 'LOGIN_CODE', // 微信、企微登录
  UPDATE_MENU_DATA = 'UPDATE_MENU_DATA', // 更新托盘菜单
  MESSAGE_NUMBER = 'MESSAGE_NUMBER', // 消息数量
  SHOW_NOTIFICATIONS = 'SHOW_NOTIFICATIONS', // 展示通知栏
  CLICK_NOTIFICATIONS = 'CLICK_NOTIFICATIONS', // 点击通知栏
  RESTART = 'RESTART', // 重启
  VIRUS_CHECK = 'VIRUS_CHECK', // 防勒索检测的通知
  VIRUS_CHECK_STATE = 'VIRUS_CHECK_STATE', // 病毒检测状态通知
  WORKER_WINDOW_CREATE = 'WORKER_WINDOW_CREATE', // 创建工作窗口
  WORKER_WINDOW_DESTORY = 'WORKER_WINDOW_DESTORY', // 销毁工作窗口
  WORKER_WINDOW_DATA_NOTIFY = 'WORKER_WINDOW_DATA_NOTIFY', // 工作窗口数据通知
  GET_WORKER_WINDOW_ID_BY_NAME = 'GET_WORKER_WINDOW_ID_BY_NAME', // 获取工作窗口ID
  WORKER_WINDOW_IPC_NOTIFY = 'WORKER_WINDOW_IPC_NOTIFY', // 工作窗口IPC的通信
  CO_SYNC_IPC_NOTIFY = 'CO_SYNC_IPC_NOTIFY', // 同步盘IPC通信
}

/**
 * @description 渲染进程中的事件集合（仅在渲染进程中使用的事件）
 * @export
 * @enum {number}
 */
export enum RENDERER_EVENTS_MAP {
  WIN_RESIZE = 'winResize', // 窗口缩放
  RETRY_RESTORE = 'retry.restore',
  RETRY_COPY = 'retry.copy',
  RETRY_MOVE = 'retry.move',
  RETRY_DELETE = 'retry.delete',
  ERRINFO_SHOW = 'errInfo.show',
  ERR_LIST_DEL = 'errList.del',
  ERR_LIST_CLEAR = 'errList.clear', // 清空错误列表
  RECYCLE_REFRESH = 'recycle.refresh',
  RESTART = 'restart', // 重启
  GUIDE_SHOW_GUIDE_TIPS = 'guide.showGuideTips', // 展示上传/新手指导tip
  LINK_LIST_FRESH = 'linkListFresh', // 分享链接list刷新
  APPLY_LIST_FRESH = 'applyListFresh', // 文件审批list刷新
  UPDATE_NOW = 'UPDATE_NOW', // 立即更新
  CHECK_UPDATE = 'CHECK_UPDATE', // 检查更新
  DRAWER_DYNAMIC_OPEN = 'drawer.dynamicOpen',
  COMMAND_REFRESH = 'command.refresh', // 刷新文件列表
  RECYCLE_FILE_SCOPE = 'recycle.fileScope', // 刷新回收站列表（根据选中文件scope范围）
  DRAWER_MANAGER_MEMBER = 'drawer.managerMember', // 获取成功列表
  ON_DATA_LOADED = 'onDataLoaded', // 数据改变、触发total改变
  RECYCLE_TOTAL = 'recycle.total',
  RESET_SEARCH = 'resetSearch', // 重置搜索
  COMMAND_SEARCH = 'command.search', // 选择搜索历史
  COMMAND_GET_SPACE_AUOTA = 'command.getSpaceQuota', // 获取空间定额
  COMMAND_SHOW_DETAIL = 'command.show-detail', // 展示文件详情
  TEAM_LIST_ACTIVEATE_BY_TEAMPATH = 'teamList.activateByTeamPath', // teamPath发生了改变
  ON_SELECTED_CHANGE = 'onSelectedChange', // 选中状态改变
  CONFLICT_SHOW = 'conflict.show',
  CONFLICT_COPY = 'conflict.copy',
  CONFLICT_MOVE = 'conflict.move',
  FAVOR_LIST_FRESH = 'favorListFresh', // 刷新收藏列表
  WEB_TRANS_SHOW = 'webTransShow', // 现实web传输列表
  COMMAND_REFRESH_SAPCE_QUOTA = 'command.refreshSpaceQuota', // 上传完成后刷新空间使用情况
  USER_INFO_CHANGE = 'userInfoChange', // 用户基本信息变更
  COMMAND_FILTER = 'command.filter', // 过滤出有操作权限的文件 - 过滤出可还原或者删除的文件
  UPGRADE_PC_NOW = 'UPGRADE_PC_NOW', // PC升级
  STOP_GUIDE = 'stopGuide', // 完成指导
  STOP_ADMIN_GUIDE = 'stopAdminGuide', // 完成管理管理中心指导
  START_ADMIN_GUIDE = 'startAdminGuide', // 开始管理中心指导
  STOP_SEARCH_GUIDE = 'stopSearchGuide', // 完成搜索页面新手引导
  SYNC_REFRESH = 'sync.refresh', // 同步刷新
  SHOW_DOWNLOAD_TIPS = 'showDownloadTips', // 显示下载提示
  SHOW_SETTING_DLG = 'showSettingDlg', // 显示设置中心
  START_GUIDE = 'startGuide', // 目的禁止点击菜单
  LOGIN_DIALOG_LOGINED = 'loginDialog.logined', // 登陆完成动作
  NOTICE_CENTER_SHOW = 'noticeCenterShow', // 消息中心的显示和隐藏
  TRANS_SHOW_CHANGE = 'transShowChange',
  OFFENCE_SHOW = 'offenceShow', // 显示举报弹窗
  TEAM_LIST_REFRESH = 'teamList.refresh', // 团队下成员更新后，获取最新成员数量
  TEAM_TREE_REFRESH = 'teamTree.refresh', // 团队树更新
  CURRENT_USER_INFO_CHANGED = 'current-user-info-changed', // 修改用户信息后，右上角需要刷新
  LOGIN_DIALOG_SHOW = 'loginDialog.show',
  LOGIN_DIALOG_HIDE = 'loginDialog.hide',
  FOCUS_LIST = 'focusList', // 聚焦文件列表
  CHANGE_SERVER_URL = 'change-serverUrl',
  REPLACE_CURRENT_PATH = 'replaceCurrentPath', // 更新路由面包屑path
  SHOW_HOT_KEY_DRAWER = 'showHotkeyHelp', // 展示快捷键的抽屉
  SHOW_GUIDE_POPUP = 'showGuidePopup', // 显示后续新手引导的气泡
  START_USER_SURVEY = 'start_user_survey', // 开启问卷调查
  SHOW_USER_SURVEY_RESULT = 'show_user_survey_result', // 显示问卷调查结果
  SHOW_INVITE_DIALOG = 'show_invite_dialog', // 显示团队邀请弹窗
  FINISH_SURVEY = 'finishSurvey', // 完成问卷调查
  FINISH_MOBILE_SURVEY = 'finish_mobile_survey', // 完成移动端问卷调查
  START_MOBILE_GUIDE = 'strat_mobile_guide', // 开始移动端的新手指引
  START_MOBILE_USER_SURVEY = 'start_mobile_user_survey', // 开启移动端会议问卷调查
  PREVIEW_CHANGE_PAGE = 'preview_change_page', // 切换上一个/下一个文档
  SHOW_NO_ENTERPRISE_DIALOG = 'show_no_enterprise_dialog', // 登录时展示没有企业的弹窗
  SSO_WEBVIEW_LOGIN = 'SSO_WEBVIEW_LOGIN', // pc端sso登录使用webview来实现
}

export const ipcMainEvents = [
  IpcEvents.SHOW_CONTEXT_MENU,
  IpcEvents.ON_OPERATE_MAIN_LISTENER,
  IpcEvents.CLICK_TITLEBAR_MAC,
  IpcEvents.CONFIRM_QUIT,
  IpcEvents.WINDOW_SHOW,
  IpcEvents.NEED_RESTART_SERVER,
  IpcEvents.COPY_TEXT,
  IpcEvents.UPDATE_MENU_DATA,
  IpcEvents.MESSAGE_NUMBER,
  IpcEvents.SHOW_NOTIFICATIONS,
  IpcEvents.RESTART,
  IpcEvents.RESTART_SERVER,
  IpcEvents.VIRUS_CHECK,
  IpcEvents.WORKER_WINDOW_CREATE,
  IpcEvents.GET_WORKER_WINDOW_ID_BY_NAME,
  IpcEvents.WORKER_WINDOW_DESTORY,
];

export const ipcRendererEvents = [
  IpcEvents.CONTEXT_MENU_CLICK,
  IpcEvents.SIGN_OUT,
  IpcEvents.WINDOW_MAXIMIZE_MAXIMIZE,
  IpcEvents.FULL_SCREEN,
  IpcEvents.WINDOW_RESIZE,
  IpcEvents.CONSOLE_LOG_MESSAGE,
  IpcEvents.UPGRADE_DOWNLOAD_PROGRESS,
  IpcEvents.CONFIRM_TRANSMISSION_PROGRESS,
  IpcEvents.RESTART_SERVER,
  IpcEvents.HANDLE_MEETING_AUTH,
  IpcEvents.LOGIN_CODE,
  IpcEvents.MENU_CLICK,
  IpcEvents.CLICK_NOTIFICATIONS,
  IpcEvents.VIRUS_CHECK_STATE,
  IpcEvents.WORKER_WINDOW_DATA_NOTIFY,
  IpcEvents.WORKER_WINDOW_IPC_NOTIFY,
];

export const WEBCONTENTS_READY_FOR_IPC_SIGNAL = 'WEBCONTENTS_READY_FOR_IPC_SIGNAL'; // 前端内容已渲染完毕，可开启 IPC 通信
